// src/pages/EmailConfirmation.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import authService from '../services/auth.service';
import { Truck, CheckCircle, XCircle, Loader2 } from 'lucide-react';

const EmailConfirmation = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    confirmEmail();
  }, [token]);

  const confirmEmail = async () => {
    try {
      await authService.confirmEmail(token);
      setStatus('success');
      setMessage('Votre email a été confirmé avec succès ! Vous pouvez maintenant vous connecter.');
      
      // Rediriger vers login après 3 secondes
      setTimeout(() => {
        navigate('/login');
      }, 3000);
      
    } catch (error) {
      setStatus('error');
      setMessage(error.message || 'Le lien de confirmation est invalide ou a expiré.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-8 text-center">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <Truck className="w-10 h-10 text-blue-600" />
            </div>
            <h1 className="text-2xl font-bold text-white">
              Confirmation d'email
            </h1>
          </div>

          {/* Content */}
          <div className="p-8">
            {status === 'loading' && (
              <div className="text-center">
                <Loader2 className="w-12 h-12 text-primary-600 animate-spin mx-auto mb-4" />
                <p className="text-gray-600">
                  Vérification de votre email en cours...
                </p>
              </div>
            )}

            {status === 'success' && (
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-10 h-10 text-green-600" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">
                  Email confirmé !
                </h2>
                <p className="text-gray-600 mb-6">
                  {message}
                </p>
                <div className="flex flex-col gap-3">
                  <Link to="/login" className="btn btn-primary">
                    Se connecter
                  </Link>
                  <p className="text-sm text-gray-500">
                    Redirection automatique dans 3 secondes...
                  </p>
                </div>
              </div>
            )}

            {status === 'error' && (
              <div className="text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <XCircle className="w-10 h-10 text-red-600" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">
                  Erreur de confirmation
                </h2>
                <p className="text-gray-600 mb-6">
                  {message}
                </p>
                <div className="flex flex-col gap-3">
                  <Link to="/register" className="btn btn-primary">
                    Créer un nouveau compte
                  </Link>
                  <Link to="/login" className="btn btn-secondary">
                    Retour à la connexion
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 text-center text-sm text-gray-600">
          © 2024 WANETERE-DELIVERY. Tous droits réservés.
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;